import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportBidsMutation,
  ExportBidsMutationVariables,
} from "../../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const exportBids = graphql(`
  mutation exportBids(
    $filters: SearchBidsRequest!
    $exportFormat: ExportFormatArgs!
    $pagination: PaginationOptions!
    $selectedBids: SelectedBids!
    $selectedFields: [String!]
  ) {
    exportBids(
      SearchBidRequest: $filters
      ExportFormat: $exportFormat
      PaginationOptions: $pagination
      SelectedBids: $selectedBids
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useBidExport(
  options?: UseMutationOptions<ExportBidsMutation, unknown, ExportBidsMutationVariables, unknown>,
) {
  const { data, ...rest } = useGraphQlMutation(exportBids, options);
  return { ...rest, data: data?.exportBids };
}
